import React from 'react';
import { Headphones, Phone, Clock, TrendingUp, ToggleLeft, ToggleRight } from 'lucide-react';

const StatCard = ({ icon: Icon, color, label, children }) => (
  <div className="bg-[#0d1117] border border-gray-800 rounded-xl p-4">
    <div className="flex items-center gap-3 mb-2">
      <Icon className={`w-5 h-5 ${color}`} />
      <span className="text-gray-400 text-sm">{label}</span>
    </div>
    {children}
  </div>
);

export const DashboardStatsRow = ({
  isAvailable,
  availabilityUpdating,
  onToggleAvailability,
  callsToday,
  minutesUsed,
  planName,
  t,
}) => (
  <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
    <div className="bg-[#0d1117] border border-gray-800 rounded-xl p-4" data-testid="availability-card">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-3">
          <Headphones className="w-5 h-5 text-teal-400" />
          <span className="text-gray-400 text-sm">{t('userDashboard.availability')}</span>
        </div>
      </div>
      <div className="flex items-center justify-between">
        <p className={`text-lg font-bold ${isAvailable ? 'text-green-400' : 'text-gray-500'}`}>
          {isAvailable ? t('userDashboard.available') : t('userDashboard.busy')}
        </p>
        <button
          onClick={onToggleAvailability}
          disabled={availabilityUpdating}
          className={`p-1 rounded-lg transition-colors ${availabilityUpdating ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-700'}`}
          data-testid="availability-toggle"
          title={isAvailable ? t('userDashboard.busy') : t('userDashboard.available')}
        >
          {isAvailable ? <ToggleRight className="w-8 h-8 text-green-400" /> : <ToggleLeft className="w-8 h-8 text-gray-500" />}
        </button>
      </div>
    </div>

    <StatCard icon={Phone} color="text-blue-400" label={t('userDashboard.callsToday')}>
      <p className="text-lg font-bold text-white" data-testid="calls-today">{callsToday}</p>
    </StatCard>

    <StatCard icon={Clock} color="text-yellow-400" label={t('userDashboard.minutesUsed')}>
      <p className="text-lg font-bold text-white" data-testid="minutes-used">{minutesUsed}</p>
    </StatCard>

    <StatCard icon={TrendingUp} color="text-purple-400" label={t('userDashboard.plan')}>
      <p className="text-lg font-bold text-white capitalize" data-testid="plan-name">{planName}</p>
    </StatCard>
  </div>
);
